export default __webpack_public_path__ + "static/media/sunset.891b8c03.png";